// extracted by mini-css-extract-plugin
module.exports = {"label":"ModalLabel_label__AjBPO"};